define.alias("shared/components/shared/mobile/drawer/layout", "preview-grid/components/shared/mobile/drawer/layout");